'use client'

import React, { useCallback } from 'react'
import { useLocale } from 'next-intl'

import { setLanguageCookie } from '@/src/utils/language'

import { LanguageToggle } from './languageToggle'

/**
 * LanguageToggle Component
 * 
 * Pill-shaped toggle for switching between English and Arabic.
 * - Shows current selected language with white background
 * - Unselected language has light blue background
 * - Clicking switches locale and redirects to /en or /ar
 */
const LanguageToggleWrapper: React.FC = () => {
    const locale = useLocale() as 'en' | 'ar'

    const handleToggle = useCallback(() => {
        const newLocale = locale === 'en' ? 'ar' : 'en'
        setLanguageCookie(newLocale)
        localStorage.setItem('selectedLanguage', newLocale)
        const base = window.location.href
        const newPath = newLocale === 'ar' ? base.replace('/en', '/ar') : base.replace('/ar', '/en')
        window.location.href = newPath
    }, [locale])
    
    return <LanguageToggle currentLocale={locale} onToggle={handleToggle} />
}

export { LanguageToggleWrapper as LanguageToggle }
export default LanguageToggleWrapper

